const JIRA_BROWSE_BASE = 'https://globe-sav.atlassian.net/browse';

export const getJiraIssueUrl = (issueKey: string): string =>
  `${JIRA_BROWSE_BASE}/${issueKey}`;
